'use strict';

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _input = require('./input');

var _input2 = _interopRequireDefault(_input);

var _baseForm = require('./base-form');

var _baseForm2 = _interopRequireDefault(_baseForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ButtonTextSubmit = _baseForm2['default'].createFormClass({

    displayName: 'ButtonTextSubmit',

    propTypes: {
        'actionButton': _react2['default'].PropTypes.element.isRequired,
        'initialValue': _react2['default'].PropTypes.string,
        'textPlaceholder': _react2['default'].PropTypes.string,
        'textClass': _react2['default'].PropTypes.string,
        'inputName': _react2['default'].PropTypes.string,
        'additionalFormData': _react2['default'].PropTypes.object,
        'validate': _react2['default'].PropTypes.func,
        'initialErrorMessage': _react2['default'].PropTypes.string,
        'errorClass': _react2['default'].PropTypes.string,
        'divClass': _react2['default'].PropTypes.string,
        'url': _react2['default'].PropTypes.string.isRequired,
        'formName': _react2['default'].PropTypes.string.isRequired,
        'initiallyShowField': _react2['default'].PropTypes.bool,
        'tabOffset': _react2['default'].PropTypes.number
    },

    onSubmit: function onSubmit(evt) {
        // always validate before acting
        evt.preventDefault();
        var isValid = this.doValidation();
        if (!isValid) {
            return false;
        }

        this.setState({
            'isSending': true,
            'inputError': false
        });

        if (this.props.additionalFormData) {
            for (var key in this.props.additionalFormData) {
                var input = $('<input>').attr('type', 'hidden').attr('key', key).attr('name', key).val(this.props.additionalFormData[key]);
                $(document.forms[name = this.props.formName]).append($(input));
            }
        }

        document.forms[name = this.props.formName].submit();

        return false;
    },
    getInitialState: function getInitialState() {
        return {
            isSending: false,
            inputError: false,
            errorMessage: this.props.initialErrorMessage
        };
    },
    handleKeyDown: function handleKeyDown(evt) {
        this.setState({ inputError: false, errorMessage: null });
        if (evt.keyCode == 13) {
            return this.onSubmit();
        }
    },
    handleTextInput: function handleTextInput(value) {
        this.setState({ text: value.trim() });
    },
    handleOnBlur: function handleOnBlur() {
        if (typeof this.state.text !== 'undefined') {
            this.doValidation();
        }
    },
    doValidation: function doValidation() {
        //FIXME: should probably move validation down into the Input component
        if (this.props.validate) {
            var inputError = this.props.validate(this.state.text);
            if (inputError) {
                this.setState({ inputError: inputError !== false, errorMessage: inputError });
                return false;
            }
        }
        return true;
    },
    render: function render() {

        var tabOffset = parseInt(this.props.tabOffset || 0, 10);

        var divClasses = {
            'm-button-submit': true,
            'is-active': true
        };
        divClasses[this.props.divClass] = true;
        var standardInput = _react2['default'].createElement(_input2['default'], {
            ref: 'textEntry',
            inputName: this.props.inputName,
            handleChange: this.handleTextInput,
            className: this.props.textClass,
            defaultValue: this.props.initialValue,
            placeholder: this.props.textPlaceholder,
            onBlur: this.handleOnBlur,
            onKeyDown: this.handleKeyDown,
            disabled: this.state.isSending,
            error: this.state.inputError,
            errorClass: this.props.errorClass,
            errorMessage: this.state.errorMessage,
            tabIndex: tabOffset });

        divClasses = (0, _classnames2['default'])(divClasses);

        var newBtnProps = {
            'onClick': this.onSubmit,
            'disabled': this.state.isSending
        };
        if (this.state.isSending) {
            newBtnProps.buttonText = 'Sending';
        }
        var btn = _react2['default'].cloneElement(this.props.actionButton, newBtnProps);

        return _react2['default'].createElement(
            'form',
            { name: this.props.formName, method: 'POST', action: this.props.url },
            _react2['default'].createElement(
                'div',
                { className: divClasses },
                this.renderCsrfField(),
                standardInput,
                btn,
                this.props.children
            )
        );
    }
});
module.exports = ButtonTextSubmit;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/button-text-submit.jsx
 ** module id = 698
 ** module chunks = 0
 **/